// 分类图标配置
const classifyIconfonts = [{
		label: '默认',
		icon_value: 'icon-classify_default'
	},
	{
		label: '网游',
		icon_value: 'icon-wangyou'
	},
	{
		label: '灯饰',
		icon_value: 'icon-dengshi'
	},
	{
		label: '情感',
		icon_value: 'icon-qinggan'
	},
	{
		label: '萌娃',
		icon_value: 'icon-mengwa'
	},
	{
		label: 'IT·游戏·动漫',
		icon_value: 'icon-IT-youxi-dongman'
	},
	{
		label: '动画·动漫',
		icon_value: 'icon-donghua-dongman'
	},
	{
		label: 'hotemall-时尚',
		icon_value: 'icon-hotemall-shishang'
	},
	{
		label: '游戏·游戏机',
		icon_value: 'icon-youxi-youxiji'
	},
	{
		label: '时尚',
		icon_value: 'icon-shishang'
	},
	{
		label: '服装时尚',
		icon_value: 'icon-fushishishang'
	},
	{
		label: '时尚设计',
		icon_value: 'icon-shishang2'
	},
	{
		label: '情感社交',
		icon_value: 'icon-qingganshejiao'
	},
	{
		label: '爱生活-商城',
		icon_value: 'icon-shangcheng'
	},
	{
		label: '爱生活-优惠劵',
		icon_value: 'icon-youhuiquan'
	},
	{
		label: '爱生活-收支记录',
		icon_value: 'icon-shouzhijilu'
	},
	{
		label: '记录',
		icon_value: 'icon-jilu'
	},
	{
		label: '记录2',
		icon_value: 'icon-jilu1'
	},
	{
		label: '时尚',
		icon_value: 'icon-shishang3'
	},
	{
		label: '时尚购物',
		icon_value: 'icon-shishanggouwu'
	},
	{
		label: '情感趋势',
		icon_value: 'icon-qingganqushi'
	},
	{
		label: '新闻',
		icon_value: 'icon-xinwen'
	},
	{
		label: '生活用品',
		icon_value: 'icon-shenghuoyongpin'
	},
	{
		label: '时尚购物',
		icon_value: 'icon-shishanggouwu1'
	},
	{
		label: '时尚-高跟鞋',
		icon_value: 'icon-shishang4'
	},
	{
		label: '情感❤',
		icon_value: 'icon-qinggan1'
	},
	{
		label: '时尚-眼镜',
		icon_value: 'icon-shishang_hei'
	},
	{
		label: '教学',
		icon_value: 'icon-w_jiaoxue'
	},
	{
		label: '情感-感情',
		icon_value: 'icon-qingganganqing'
	}
	// {
	// 	label: '',
	// 	icon_value: ''
	// }
];
// 导出配置
export default classifyIconfonts;